module.exports = __webpack_public_path__ + "static/img/4117_phase_function_Paper_PointsHejduk_Prediction.090378e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4117_phase_function_Paper_PointsHejduk_Prediction.png
// module id = d2Yn
// module chunks = 0